import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Menu,
  MenuItem
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import { closeDialogConfirm } from 'src/features/uiSlice';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';

const ConfirmDialogs = ({
  anchorEl,
  handleMenuClose,
  menuOrder,
  isAdmin,
  isSale,
  isAccountant,
  handleEditOrder,
  handleDeleteOrder,
  handleCancelOrder,
  confirmDelete,
  openCompleteConfirm,
  setOpenCompleteConfirm,
  confirmComplete,
  openCancelConfirm,
  setOpenCancelConfirm,
  confirmCancel
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {menuOrder && (isAdmin || isSale) && (
          <MenuItem
            onClick={() => {
              handleEditOrder(menuOrder);
              handleMenuClose();
            }}
            disabled={menuOrder.status >= 4}
            style={{ color: '#2980b9' }}
          >
            <EditIcon fontSize="small" style={{ marginRight: 8 }} />
            Sửa phiếu
          </MenuItem>
        )}
        {menuOrder && menuOrder.status < 3 && isAdmin && (
          <MenuItem onClick={handleDeleteOrder} style={{ color: '#d32f2f' }}>
            <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
            Xóa phiếu
          </MenuItem>
        )}
        {menuOrder &&
          menuOrder.status !== -1 &&
          menuOrder.status < 4 &&
          (isAdmin || isAccountant || isSale) && (
            <MenuItem onClick={handleCancelOrder} style={{ color: '#666' }}>
              <CloseIcon fontSize="small" style={{ marginRight: 8 }} />
              Hủy phiếu
            </MenuItem>
          )}
      </Menu>

      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_ORDER}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_ORDER}
        callbackOk={confirmDelete}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />

      <Dialog
        open={openCompleteConfirm}
        onClose={() => setOpenCompleteConfirm(false)}
      >
        <DialogTitle>
          <Typography
            variant="h5"
            style={{ fontWeight: 700, color: '#1a1f36' }}
          >
            Xác nhận hoàn thành
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            Bạn có chắc chắn muốn hoàn thành đơn hàng này không?
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: 8 }}
          >
            Sau khi hoàn thành, đơn hàng sẽ được đánh dấu đã thanh toán và bị
            khóa, không thể chỉnh sửa thông tin nữa.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: 16 }}>
          <Button
            onClick={() => setOpenCompleteConfirm(false)}
            variant="outlined"
            color="primary"
            style={{ fontWeight: 600 }}
          >
            Hủy
          </Button>
          <Button
            onClick={confirmComplete}
            variant="contained"
            color="primary"
            style={{ fontWeight: 600 }}
          >
            Đồng ý
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCancelConfirm}
        onClose={() => setOpenCancelConfirm(false)}
      >
        <DialogTitle>
          <Typography
            variant="h5"
            style={{ fontWeight: 700, color: '#1a1f36' }}
          >
            Xác nhận hủy đơn
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            Bạn có chắc chắn muốn hủy đơn hàng này không?
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: 8 }}
          >
            Sau khi hủy, các thao tác cho đơn hàng này sẽ bị khóa.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: 16 }}>
          <Button
            onClick={() => setOpenCancelConfirm(false)}
            variant="outlined"
            color="primary"
            style={{ fontWeight: 600 }}
          >
            Đóng
          </Button>
          <Button
            onClick={confirmCancel}
            variant="contained"
            color="secondary"
            style={{ fontWeight: 600 }}
          >
            Xác nhận hủy
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmDialogs;
